export default [
  {
    name: 'Script Pay Go',
    description:
      'Includes access to our script coverage plus an automated material log. Adjust quantity to add more books per month.',
    price: 8,
    period: 'month',
    features: [
      'Includes 1 Script Reports per Month',
      '14 Day Free Trial: 1 Script Reports & 1 Book Report',
      'Purchase Additional Book or Script Reports As Needed',
      'Automated Material Log',
      'Draft Comparison',
      'Query',
      'Company Collaboration'
    ]
  },
  {
    name: 'Book Pay Go',
    description:
      'Includes access to our book coverage plus an automated material log. Adjust quantity to add more books per month.',
    price: 10,
    period: 'month',
    features: [
      'Includes 1 Book Report per Month',
      '14 Day Free Trial: 1 Script Reports & 1 Book Report',
      'Purchase Additional Book or Script Reports As Needed',
      'Automated Material Log',
      'Draft Comparison',
      'Query',
      'Company Collaboration'
    ]
  },
  {
    name: 'Scripts Bundle',
    description:
      'Includes access to our script coverage plus an automated material log. Adjust quantity to add more scripts per month.',
    price: 30,
    period: 'month',
    features: [
      'Includes 4 Script Reports per Month',
      '14 Day Free Trial: 1 Script Reports & 1 Book Reports',
      'Purchase Additional Script or Book Reports As Needed',
      'Automated Material Log',
      'Draft Comparison',
      'Query',
      'Company Collaboration'
    ]
  },
  {
    name: 'Books Bundle',
    description:
      'Includes access to our book coverage plus an automated material log. Adjust quantity to add more books per month.',
    price: 30,
    period: 'month',
    features: [
      'Includes 3 Book Reports per Month',
      '14 Day Free Trial: 1 Script Reports & 1 Book Report',
      'Purchase Additional Book or Script Reports As Needed',
      'Automated Material Log',
      'Draft Comparison',
      'Query',
      'Company Collaboration'
    ]
  }
];
